define(['angular', 'morningstar', 'underscore', './transforms/date-helper'], function(angular, morningstar, _, dateHelper) {
    'use strict';
    angular.module('ecMultipleChart', [
            'ecAutocomplete',
            'ecButton',
            'ecChosen',
            'ecComboBox',
            'ecContainer',
            'ecHypotheticalGrowth',
            'ecInput',
            'ecPerformanceGraph',
            'ecTable',
            'ecTabs',
            'mstarCore'
        ])
        .directive('ecMultipleChart', multipleChart);

    function multipleChart(mstarModelValidate, mstarValidationMessageContainers, exportCSV) {
        return {
            restrict: 'E',
            require: 'mstarComponentId',
            scope: {},
            template: morningstar.asterix.ng.util.createTemplateFunction('_templates.main'),
            link: linkFn
        };

        function linkFn(scope, elem, attr, mstarComponent) {
            // binds settings, labels, formatter and templates to scope properties
            mstarComponent.bindConfig(scope);

            // compiles the main template
            mstarComponent.compileTemplate(scope, '_templates.main');

            // binds parameters (two-way between the asterix instance's parameters and scope.parameters)
            mstarComponent.bindParameters(scope);

            // initiates our scope.model according to settings and two-way binds it to the asterix instance's model
            mstarComponent.bindModelData(scope, { editable: true });
            // ..or mstarComponent.bindModel(scope) (in a non-databound directive) to only bind between scope and asterix's model.

            var inputStartDateInstance = scope.instance.findRelative('inputStartDate');
            var inputEndDateInstance = scope.instance.findRelative('inputEndDate');
            var autocompletePrimaryFund = scope.instance.findRelative('autocompletePrimaryFund');
            var autocompleteComparisonFund = scope.instance.findRelative('autocompleteComparisonFund');
            var chosenReinvestDistributions = scope.instance.findRelative('chosenReinvestDistributions');
            var buttonExport = scope.instance.findRelative('buttonExport');

            initialChartSettings();

            mstarModelValidate.bind(scope.instance);
            scope.validationContainer = mstarValidationMessageContainers.register(scope.instance, function handleMessages(validationMessages) {
                scope.getErrorMessage(validationMessages, validationMessages.getErrors().length);
                var primaryFundsecId = scope.model.chartSettings.primaryFund.secId;
                if (!primaryFundsecId) {
                    scope.model.securities.priceTableData = [];
                    scope.showPriceTable = false;
                }
            });

            const formElements = {};

            scope.getErrorMessage = function(validationMessages, length) {
                scope.validationErrors = null;
                let form = elem.find('form[name="enterData"]').scope();
                form = form && form.enterData || {};

                const obj = {};

                _.each(validationMessages._messages, (item, key) => {
                    const reference = key.split('_');
                    const component = reference[reference.length - 1];

                    formElements[component] = formElements[component] || form[component] || {
                        $setValidity: angular.noop
                    };
                    formElements[component].$setValidity(item.rule.labelKey, item.returnValue);

                    if (length > 0 && !item.returnValue) {
                        obj[item.rule.labelKey] = item.label;
                    }
                });

                var startDate = scope.model.chartSettings.startDate;
                var endDate = scope.model.chartSettings.endDate;
                if (startDate && endDate && startDate >= endDate) {
                    obj.startDateRequired = scope.labels.get('maxStartDate');
                    formElements.inputStartDate.$setValidity('startDateRequired', false);
                }
                if (endDate && endDate > new Date()) {
                    obj.endDateRequired = scope.labels.get('maxEndDate');
                    formElements.inputEndDate.$setValidity('endDateRequired', false);
                }

                var initialInvestmentAmount = scope.model.chartSettings.initialInvestmentAmount;
                if (morningstar.asterix.util.isUndefinedOrNull(initialInvestmentAmount) || initialInvestmentAmount < 0 || (morningstar.asterix.util.isNumber(initialInvestmentAmount) && initialInvestmentAmount.toString().indexOf('.') > -1)) {
                    obj.initialAmountRequired = scope.labels.get('fieldShouldBeInteger');
                    formElements.inputInitialAmount.$setValidity('initialAmountRequired', false);
                }

                var amount = scope.model.chartSettings.amount;
                if (morningstar.asterix.util.isUndefinedOrNull(amount) || amount < 0 || (morningstar.asterix.util.isNumber(amount) && amount.toString().indexOf('.') > -1)) {
                    obj.amountRequired = scope.labels.get('fieldShouldBeInteger');
                    formElements.inputAmount.$setValidity('amountRequired', false);
                }
                if (obj.amountRequired && scope.activeType === 'priceChart') {
                    delete obj.amountRequired;
                    formElements.inputAmount.$setValidity('amountRequired', true);
                }
                if (obj.initialAmountRequired && scope.activeType === 'priceChart') {
                    delete obj.initialAmountRequired;
                    formElements.inputInitialAmount.$setValidity('initialAmountRequired', true);
                }
                scope.validationErrors = obj;
            };

            scope.setActiveView = function(index) {
                setActiveView(index);
            };

            function setActiveView(index) {
                var view = scope.settings.get('views')[index];
                if (view) {
                    scope.activeType = view;
                }
            }

            function setInceptionDate() {
                var timeFrame = scope.model.chartSettings.timeFrame;
                if (timeFrame && timeFrame.key === 'sinceInception') {
                    var primaryFund = scope.model.chartSettings.primaryFund;
                    var comparisonFund = scope.model.chartSettings.comparisonFund;
                    scope.model.chartSettings.startDate = scope.inceptionDate = _.max([dateHelper.toDateObject(primaryFund.performanceStartDate) || primaryFund.inceptionDate, dateHelper.toDateObject(comparisonFund.performanceStartDate) || comparisonFund.inceptionDate || null]);
                }
            }

            function setDisplayFrequency() {
                var tabFrequencyInstance = scope.instance.findRelative('hypotheticalGrowthChart.performanceGraph.tabFrequency');
                if (tabFrequencyInstance.parameters.selectedTabIndex > -1) {
                    tabFrequencyInstance.setParameter('selectedTabIndex', -1);
                    tabFrequencyInstance.setParameter('resetTabStatus', true);
                }

                var displayFrequency = [{
                    labelKey: 'oneYear',
                    value: 'Year1',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'threeYears',
                    value: 'Year3',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'fiveYears',
                    value: 'Year5',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'tenYears',
                    value: 'Year10',
                    dataType: 'TrailingReturn'
                }, {
                    labelKey: 'inception',
                    value: 'EarliestCommon',
                    dataType: 'TrailingReturn'
                }];
                var monthCount = morningstar.asterix.util.date.monthDiff(scope.inceptionDate, new Date());
                var commonYear = Math.floor(monthCount / 12);
                _.each(displayFrequency, function(item) {
                    item.value = commonYear < Number(item.value.replace(/Year/, '')) ? 'EarliestCommon' : item.value;
                });
                scope.instance.findRelative('hypotheticalGrowthChart').setParameter('displayFrequency', displayFrequency);
            }

            scope.reset = function() {
                initialChartSettings();
                autocompletePrimaryFund.setParameter('search', '');
                autocompleteComparisonFund.setParameter('search', '');
                chosenReinvestDistributions.setParameter('buttonItemSelected', scope.model.chartSettings.reinvestDistributions);
                scope.validationErrors = {};
                scope.validationContainer.deactivate(false);
                scope.model.securities.priceTableData = [];
                scope.showPriceTable = false;
                scope.showHypoGrowthChart = false;
            };

            function initialChartSettings() {
                scope.model.chartSettings = {
                    primaryFund: {},
                    comparisonFund: {},
                    timeFrame: {
                        key: 'sinceInception',
                        value: 'sinceInception',
                        timeFrame: 'sinceInception',
                        list: 1
                    },
                    startDate: null,
                    endDate: new Date(),
                    initialInvestmentAmount: 10000,
                    investmentType: {
                        key: 'invest',
                        value: 'contribution',
                        investmentType: 'contribution',
                        list: 1
                    },
                    amount: 0,
                    frequency: {
                        key: 'annually',
                        value: 'annually',
                        frequency: 'annually',
                        list: 1
                    },
                    reinvestDistributions: 'yes'
                };
            }

            scope.parameters.readyForAPI = false;
            scope.export = function() {
                scope.parameters.readyForAPI = true;
            };

            scope.isLoading = false;
            scope.isSubmit = false;
            scope.showHypoGrowthChart = false;
            scope.submit = function() {
                scope.validationContainer.activate(true);

                if (Object.keys(scope.validationErrors).length < 1) {
                    scope.isSubmit = true;
                    var primaryFundsecId = scope.model.chartSettings.primaryFund.secId;
                    var comparisonFundsecId = scope.model.chartSettings.comparisonFund.secId;
                    var startDate = scope.model.chartSettings.startDate;
                    var endDate = scope.model.chartSettings.endDate;
                    if (scope.activeType === 'hypotheticalGrowthChart') {
                        getHypoGrowthChart(primaryFundsecId, comparisonFundsecId, startDate, endDate);
                    } else {
                        getPriceChart(primaryFundsecId, comparisonFundsecId, startDate, endDate);
                    }
                }
            };

            function getPriceChart(primaryFundsecId, comparisonFundsecId, startDate, endDate) {
                var secIds = comparisonFundsecId ? primaryFundsecId + ',' + comparisonFundsecId : primaryFundsecId;
                scope.instance.setParameter('secIds', secIds);
                scope.instance.setParameter('inceptionDate', scope.inceptionDate);
                scope.instance.setParameter('startDate', startDate);
                scope.instance.setParameter('endDate', endDate);
                if (scope.instance.findRelative('priceChart.tabFrequency').parameters.selectedTabIndex > -1) {
                    scope.instance.findRelative('priceChart.tabFrequency').setParameter('resetTabStatus', true);
                }
                scope.showPriceTable = true;
            }

            function getHypoGrowthChart(primaryFundsecId, comparisonFundsecId, startDate, endDate) {
                setDisplayFrequency();

                scope.model.performanceData.rows = [];
                var primaryFund = scope.model.chartSettings.primaryFund;
                var comparisonFund = '';
                scope.model.performanceData.rows.push({
                    name: !primaryFund.currency ? primaryFund.name : primaryFund.name + ' ' + primaryFund.currency,
                    universe: primaryFund.universe,
                    returnM12: primaryFund.returnM12,
                    returnM36: primaryFund.returnM36,
                    returnM60: primaryFund.returnM60,
                    returnM120: primaryFund.returnM120,
                    returnM255UA: primaryFund.returnM255UA,
                    marketTrailing1YearReturn: primaryFund.marketTrailing1YearReturn,
                    marketTrailing3YearReturn: primaryFund.marketTrailing3YearReturn,
                    marketTrailing5YearReturn: primaryFund.marketTrailing5YearReturn,
                    marketTrailing10YearReturn: primaryFund.marketTrailing10YearReturn,
                    marketSinceInceptionReturn: primaryFund.marketSinceInceptionReturn,
                    inceptionDate: morningstar.asterix.util.date.convertToStandard(dateHelper.toDateObject(primaryFund.performanceStartDate) || primaryFund.inceptionDate)
                });
                if (comparisonFundsecId) {
                    comparisonFund = scope.model.chartSettings.comparisonFund;
                    scope.model.performanceData.rows.push({
                        name: !comparisonFund.currency ? comparisonFund.name : comparisonFund.name + ' ' + comparisonFund.currency,
                        universe: comparisonFund.universe,
                        returnM12: comparisonFund.returnM12,
                        returnM36: comparisonFund.returnM36,
                        returnM60: comparisonFund.returnM60,
                        returnM120: comparisonFund.returnM120,
                        returnM255UA: comparisonFund.returnM255UA,
                        marketTrailing1YearReturn: comparisonFund.marketTrailing1YearReturn,
                        marketTrailing3YearReturn: comparisonFund.marketTrailing3YearReturn,
                        marketTrailing5YearReturn: comparisonFund.marketTrailing5YearReturn,
                        marketTrailing10YearReturn: comparisonFund.marketTrailing10YearReturn,
                        marketSinceInceptionReturn: comparisonFund.marketSinceInceptionReturn,
                        inceptionDate: morningstar.asterix.util.date.convertToStandard(dateHelper.toDateObject(comparisonFund.performanceStartDate) || comparisonFund.inceptionDate)
                    });
                }
                var portfolio = comparisonFundsecId ? {
                    current: {
                        name: !primaryFund.currency ? primaryFund.name : primaryFund.name + ' ' + primaryFund.currency,
                        currencyId: primaryFund.currency,
                        holdings: [{
                            identifier: primaryFundsecId,
                            identifierType: 'SecurityId',
                            amount: scope.model.chartSettings.initialInvestmentAmount
                        }]
                    },
                    proposed: {
                        name: !comparisonFund.currency ? comparisonFund.name : comparisonFund.name + ' ' + comparisonFund.currency,
                        currencyId: comparisonFund.currency,
                        holdings: [{
                            identifier: comparisonFundsecId,
                            identifierType: 'SecurityId',
                            amount: scope.model.chartSettings.initialInvestmentAmount
                        }]
                    }
                } : {
                    name: !primaryFund.currency ? primaryFund.name : primaryFund.name + ' ' + primaryFund.currency,
                    currencyId: primaryFund.currency,
                    holdings: [{
                        identifier: primaryFundsecId,
                        identifierType: 'SecurityId',
                        amount: scope.model.chartSettings.initialInvestmentAmount
                    }]
                };
                var hypotheticalSettings = {
                    illustrationTrailingTimePeriod: 'customized',
                    startDate: dateHelper.toUTCDateObject(_.max([scope.inceptionDate, startDate])),
                    endDate: dateHelper.toUTCDateObject(endDate),
                    subsequentInvestmentType: scope.model.chartSettings.investmentType.key || scope.settings.get('defaultInvestmentType'),
                    subsequentInvestmentAmount: scope.model.chartSettings.amount,
                    subsequentInvestmentWithdrawalFrequency: scope.model.chartSettings.frequency.key || scope.settings.get('defaultFrequency'),
                    reinvestDividends: scope.model.chartSettings.reinvestDistributions === 'yes',
                    initialInvestmentAmount: scope.model.chartSettings.initialInvestmentAmount
                };

                var hypotheticalGrowthChart = scope.instance.findRelative('hypotheticalGrowthChart');
                hypotheticalGrowthChart.setParameter('portfolio', portfolio);
                hypotheticalGrowthChart.setParameter('hypotheticalSettings', hypotheticalSettings);
            }

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:chartSettings.timeFrame', function(newTimeFrame) {
                if (newTimeFrame && newTimeFrame.key) {
                    var disable = newTimeFrame.key === 'sinceInception';
                    inputStartDateInstance.setParameter('disabled', disable);
                    inputEndDateInstance.setParameter('disabled', disable);

                    if (disable) {
                        scope.model.chartSettings.endDate = new Date();
                    }
                    if (scope.model.chartSettings.primaryFund && newTimeFrame.key === 'sinceInception') {
                        setInceptionDate();
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(chosenReinvestDistributions.on('parameterChanged:buttonItemSelected', function(newValue) {
                if (newValue) {
                    scope.model.chartSettings.reinvestDistributions = newValue;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('priceTable').on('modelPropertyChanged:rows', function(rows) {
                if (rows) {
                    scope.isLoading = rows._$isLoading && scope.isSubmit;
                    scope.showPriceTable = rows.length > 0;
                }
                buttonExport.setParameter('disabled', !scope.showPriceTable);
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypotheticalGrowthChart.portfolioData').on('modelPropertyChanged:securities', function(securities) {
                if (securities) {
                    scope.isLoading = securities._$isLoading && scope.isSubmit;
                    if (securities.performanceChart) {
                        scope.showHypoGrowthChart = true;
                    }

                    if (securities.hypoDates) {
                        scope.model.performanceData.asofDate = securities.hypoDates.asOfDate;
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:priceAndDistributions', function(securities) {
                if (securities.name) {
                    var exportSettings = scope.settings.get('exportSettings');
                    var headers = [];
                    _.each(exportSettings.columnOrder, function(item) {
                        var header = morningstar.asterix.util.string.format(scope.labels.get(item), scope.format.currencySymbol(scope.model.currencyId));
                        headers.push(header);
                    });
                    var options = {
                        title: securities.name,
                        header: headers,
                        columnOrder: exportSettings.columnOrder
                    };
                    exportCSV.exportData(securities.rows, options);
                    scope.parameters.readyForAPI = false;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:chartSettings.primaryFund.secId', function(primaryFundSecId) {
                if (primaryFundSecId) {
                    setInceptionDate();
                    buttonExport.setParameter('disabled', true);
                }
            }));
            mstarComponent.addUnregisterCallback(scope.instance.on('modelPropertyChanged:chartSettings.comparisonFund.secId', function(comparisonFundSecId) {
                if (comparisonFundSecId) {
                    setInceptionDate();
                    buttonExport.setParameter('disabled', true);
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:startDate', function(newValue) {
                if (newValue && scope.instance.findRelative('priceChart.tabFrequency').parameters.selectedTabIndex !== 5) {
                    scope.model.chartSettings.startDate = newValue;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.on('parameterChanged:endDate', function(newValue) {
                if (newValue && scope.instance.findRelative('priceChart.tabFrequency').parameters.selectedTabIndex !== 5) {
                    scope.model.chartSettings.endDate = newValue;
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('priceChart.tabFrequency').on('parameterChanged:selectedTabIndex', function(newValue) {
                if (newValue >= 0) {
                    if (newValue === 5) {
                        scope.model.chartSettings.timeFrame = { key: 'sinceInception', value: 'sinceInception' };
                    } else {
                        scope.model.chartSettings.timeFrame = { key: 'customized', value: 'custom' };
                    }
                }
            }));

            mstarComponent.addUnregisterCallback(scope.instance.findRelative('hypotheticalGrowthChart.performanceGraph.tabFrequency').on('parameterChanged:selectedTabIndex', function(newValue) {
                scope.instance.findRelative('hypotheticalGrowthChart').setParameter('hypotheticalSettings', null);
                if (newValue >= 0) {
                    if (newValue === 4) {
                        scope.model.chartSettings.timeFrame = { key: 'sinceInception', value: 'sinceInception' };
                    } else {
                        scope.model.chartSettings.timeFrame = { key: 'customized', value: 'custom' };
                    }
                }
            }));
        }
    }
});


// WEBPACK FOOTER //
// ./components/multiple-chart/src/js/multiple-chart.js